import { useEffect } from "react";
import { FiX } from "react-icons/fi";
import SongComments from "./SongComments";
import "./songCommentModal.css";

export default function SongCommentsModal({
  song,
  onClose,
}) {
  /* ================= BODY SCROLL LOCK ================= */

  useEffect(() => {
    if (!song) return;

    document.body.style.overflow = "hidden";

    const handleEsc = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };

    window.addEventListener("keydown", handleEsc);

    return () => {
      document.body.style.overflow = "auto";
      window.removeEventListener("keydown", handleEsc);
    };
  }, [song, onClose]);

  /* ================= SAFETY RETURN ================= */

  if (!song) return null;

  /* ================= RENDER ================= */

  return (
    <div
      className="song-comment-modal-overlay"
      onClick={onClose}
    >
      <div
        className="song-comment-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="song-modal-header">
          <h3>Comments</h3>
          <FiX className="song-close-btn" onClick={onClose} />
        </div>

        <div className="song-modal-body">

          {/* ? Correct thumbnail field */}
          {song.thumbnailUrl && (
            <div className="song-modal-image">
              <img src={song.thumbnailUrl} alt={song.title} />
            </div>
          )}

          <div className="song-modal-comments">
            {/* ? Backend-based comment fetch */}
            <SongComments songId={song._id} />
          </div>

        </div>
      </div>
    </div>
  );
}